import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'value-added-programme-students',
  templateUrl: './component.html',
  styleUrls: ['./component.css']
})
export class ValueAddedProgramStudentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
